/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgButtonGroup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 6c3.308 0 6 2.691 6 6a6.007 6.007 0 0 1-5.775 5.996L16 18H8c-3.308 0-6-2.691-6-6s2.692-6 6-6zM8 8c-2.206 0-4 1.794-4 4s1.794 4 4 4zm6 0h-4v8h4zm2 0v8c2.206 0 4-1.794 4-4s-1.794-4-4-4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgButtonGroup as ButtonGroup };
